import { klwAxios, mock } from "helpers/api";

const MOCK_DATA_KOTO =
{
  isKotoPercelenEnabled: true,
  kotoPercelenMelding: "Helaas is de Koppeltool tijdelijk niet te gebruiken in KringloopWijzer. De noodzakelijke informatie die van de GEO-service van de WUR verkregen moet worden is op dit moment niet beschikbaar. Zodra de informatie via de GEO-Service van de WUR weer beschikbaar is, kan Koppeltool weer gebruikt worden.",
};

export type KotoDataModel = typeof MOCK_DATA_KOTO;

export const GetKotoBeheerApplicatieInstellingen = () =>
  klwAxios
    .get<KotoDataModel>("/BeheerApplicatieInstellingen/GetKotoBeheerApplicatieInstellingen")
    .then((r) => r.data);

mock.onGet("/BeheerApplicatieInstellingen/GetKotoBeheerApplicatieInstellingen").reply(200, MOCK_DATA_KOTO);
